export enum CardCurrenyType {
    AZN = "AZN",
    USD = "USD",
    EUR = "EUR",
}

export enum CardType {
    VISA = "VISA",
    MASTERCARD = "MASTERCARD"
}

export enum OrderType {
    ORDINARY = "ORDINARY",
    URGENT = "URGENT",
}

export enum OrderDeliveryType {
    BANK = "BANK",
    COURIER = "COURIER"
}

export enum PasswordType {
    AA = "AA",
    AB = "AB",
    AZE = "AZE"
}

export enum StatusType {
    FOR_MUST_BE_SIGNED = "FOR_MUST_BE_SIGNED",
    CLOSED = "CLOSED",
    BANK_EXECUTION = "BANK_EXECUTION",
    DELETED = "DELETED",
    EXPIRED = "EXPIRED",
    BANK_REJECTED = "BANK_REJECTED",
    BANK_SUCCESS = "BANK_SUCCESS",
    BANK_ERROR = "BANK_ERROR",
    PENDING_SIGNER = "PENDING_SIGNER",
    SEND_TO_BANK = "SEND_TO_BANK",
    PROCEED = "PROCEED",
    CREATED = "CREATED",
    EDITED = "EDITED",
    CARD_READY = 'CARD_READY',
    CARD_RECEIVED = 'CARD_RECEIVED',
}